<template>

    <footer class="c-legend">
        <ul class="c-legend__list">
            <li class="c-legend__item">
                <span class="c-legend__item-el c-legend__item-el--v_office"></span>
                <span class="c-legend__item-name">Wizyta w gabinecie</span>
            </li>
            <li class="c-legend__item">
                <span class="c-legend__item-el c-legend__item-el--v_mobile"></span>
                <span class="c-legend__item-name">Wizyta domowa</span>
            </li>
            <li class="c-legend__item">
                <span class="c-legend__item-el c-legend__item-el--v_finished"></span>
                <span class="c-legend__item-name">Wizyta rozpoczęta/zakończona</span>
            </li>
            <li class="c-legend__item">
                <span class="c-legend__item-el c-legend__item-el--v_block"></span>
                <span class="c-legend__item-name">Blokada</span>
            </li>
        </ul>
        <div class="c-legend__calendar-availability">
            <span class="c-legend__calendar-availability__text">Zdefiniowana dostępność w portalu do rejestracji online </span>
        </div>
    </footer>

</template>


<script>

export default {

    name: 'VCalendarLegend',

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-legend {
    margin: 1rem 0;

    &__item {
        display: inline-block;
        margin-right: 1.5rem;

        &-el {
            display: inline-block;
            width: 0.7rem;
            height: 0.7rem;
            border-radius: 50%;
            margin-right: .5rem;

            &--v_mobile {
                background-color: $c-third;
            }
            &--v_office {
                background-color: $c-primary;
            }
            &--v_finished {
                background-color: $c-secondary;
            }
            &--v_block {
                background-color: #ea9343;
            }
        }
    }
    @include bp($screen-md) {
        &__list {
            padding: 0 1rem;
        }
        &__item {
            margin: 0;
            display: block;
        }
    }

    &__calendar-availability {
        display: inline-block;
        background: rgba($c-primary, 0.24);
        padding: 5px 10px;
        margin-top: 10px;

        &__text {
            color: #637280;
            opacity: 1;
        }
    }
}

</style>
